export type DensityMode = 'comfortable' | 'compact' | 'dense';

export const DENSITY_SCALES: Record<DensityMode, number> = {
    comfortable: 1,
    compact: 0.9,
    dense: 0.8,
};

const densityFromEnv = import.meta.env.VITE_UI_DENSITY as DensityMode | undefined;
export const DENSITY_MODE: DensityMode =
    densityFromEnv != null && Object.prototype.hasOwnProperty.call(DENSITY_SCALES, densityFromEnv)
        ? densityFromEnv
        : 'dense';

export const UI_SCALE = DENSITY_SCALES[DENSITY_MODE];

export const BASE_FONT_PX = 16;
export const BASE_SPACE_PX = 8;

const toFixedNumber = (value: number, precision = 4) => Number(value.toFixed(precision));

export const scale = (value: number) => toFixedNumber(value * UI_SCALE);

export const toRem = (px: number) => `${toFixedNumber(px / BASE_FONT_PX)}rem`;

export const scaledRem = (rem: number) => `${toFixedNumber(rem * UI_SCALE)}rem`;

const scaledRemFromPx = (px: number) => toRem(scale(px));

export const spacingUnit = scale(BASE_SPACE_PX);

export const controlHeights = {
    sm: scale(32),
    md: scale(40),
    lg: scale(48),
};

export const iconSizes = {
    sm: scale(16),
    md: scale(20),
    lg: scale(24),
};
